module.exports = __webpack_public_path__ + "static/media/screenshot_3.620b571a.png";